import { Platform } from "../constants";

import { ConstructDestinationUrl, URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.LIVE_INTENT;

export const LiveIntentDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const LiveIntentSetup = () => (
  <>
    <ConstructDestinationUrl platform={PLATFORM} />
    <URLVerification platform={PLATFORM} />
  </>
);
